module.exports = __webpack_public_path__ + "static/media/field-multimedia.45e3c5df.svg";